// O backend fornece a categoria do catálogo; ausência mantém o legado em Escolas.
export function camposInstituicaoProcesso(dados) {
  const mantenedora = dados.tipo_instituicao === "mantenedora";
  return [
    { rotulo: mantenedora ? "Mantenedora" : "Escola", valor: dados.schoolname || dados.nome_escola || "Não informado" },
    ...(!mantenedora && dados.mantenedora_nome
      ? [{ rotulo: "Mantenedora vinculada", valor: dados.mantenedora_nome }] : []),
  ];
}
